/**
* @name: img-file
* @author: weiyong
* @date: 2024-03-23 17:04
* @description：img-file
* @update: 2024-03-23 17:04
*/
<template>
  <div class="file-show-item other-file">
    <file-show-item @downFile="downFile"
                    :businessId="businessId"
                    @remove="handleRemove"
                    @preview="handlePreview" :fileAclInfo="fileAclInfo" :fileItem="fileItem"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "other-file",
});
</script>

<script lang="ts" setup>
import FileShowItem from "@/components/xmFileComCtl/coms/file-show-item.vue";


import {useFilePreviewHook} from "@/components/xmFileComCtl/hooks/useFilePreviewHook";
interface Props {
  businessId:string,
  fileAclInfo:any,
  fileItem:any,
}

const props = withDefaults(defineProps<Props>(), {
  businessId:"",
  fileAclInfo:{},
  fileItem:{}
});
const {fileAclInfo}=toRefs(props);

const emit = defineEmits<{
  (event: "preview", value: any): void;
  (event: "remove", value: any): void;
  (event: "downFile", value: any): void;
}>();

const fileConfigs = inject('fileConfigs')
const {handlePreview} = useFilePreviewHook({fileObjRef: null, fileConfigs});
// 下载
const downFile = (fileItem) => {
  emit("downFile", fileItem);
};

// 删除
const handleRemove = (fileItem) => {
  emit("remove", fileItem);
};
</script>

<style type="text/css" lang="less">

</style>
